
import {debounceTime} from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { AfterContentInit, Component, Input, OnChanges, OnInit } from '@angular/core';

import { HistoryOps } from '../../../core/model/history-ops.model';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { LocoHistory } from '../../../core/model/loco-history.model';

@Component({
  selector: 'lms-loco-history-details',
  templateUrl: './loco-history-details.component.html',
  styleUrls: ['./loco-history-details.component.scss']
})
export class LocoHistoryDetailsComponent implements OnInit, AfterContentInit, OnChanges {

  @Input() history: LocoHistory;
  @Input() historyOps: HistoryOps;

  commonHistoryHeight: number;
  thpHistoryHeight: number;
  upperHeight = 189;
  spaceBetweenTable = 130;

  /**
   * Creates an instance of LocoHistoryDetailsComponent.
   * @memberOf LocoHistoryDetailsComponent
   */
  constructor(private lmsRendererService: LmsRendererService) {
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.prepareHeightForPage();
        this.reCalculateScrollHeight();
      }
    });
   }

   ngOnChanges() {
     if (this.history && ((this.history.history && this.history.history.length > 0) || (this.history.thpHistory && this.history.thpHistory.length > 0))) {
       this.prepareHeightForPage();
       this.reCalculateScrollHeight();
     }
   }

  /**
   * this is the life cycle method od this component
   * and called on initialization of this component
   * @memberOf LocoHistoryDetailsComponent
   */
  ngOnInit() {
    this.prepareHeightForPage();
  }

  private prepareHeightForPage() {
    const windowHeight = this.lmsRendererService.getWindowHeight();
    const availableHeight = windowHeight - this.upperHeight - this.spaceBetweenTable;
    this.commonHistoryHeight = Math.ceil((availableHeight * 60) / 100);
    this.thpHistoryHeight = Math.ceil((availableHeight * 40) / 100);
  }

  ngAfterContentInit() {
    if (this.history && this.history.thpHistory && this.history.thpHistory.length > 0) {
      this.reCalculateScrollHeight();
    }
  }

  private reCalculateScrollHeight() {
    const windowHeight = this.lmsRendererService.getWindowHeight();
    const availableHeight = windowHeight - this.upperHeight - this.spaceBetweenTable;
    let historyHeight = Math.ceil((availableHeight * 60) / 100);
    let thpHistoryHeight = Math.ceil((availableHeight * 40) / 100);
    if ((thpHistoryHeight / 40) > this.history.thpHistory.length) {
      thpHistoryHeight = this.history.thpHistory.length * 38 + 25;
      historyHeight = availableHeight - thpHistoryHeight - 5;
    }
    if ((historyHeight / 40) > this.history.history.length && (thpHistoryHeight / 38) > this.history.thpHistory.length) {
      historyHeight = Math.ceil((availableHeight * 60) / 100);
      thpHistoryHeight = Math.ceil((availableHeight * 40) / 100);
    }
    this.commonHistoryHeight = historyHeight;
    this.thpHistoryHeight = thpHistoryHeight;
  }

}
